// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const bastiodon: PokeData = {
  "id": 411,
  "name": "bastiodon",
  "height": 13,
  "weight": 1495,
  "base_experience": 173,
  "types": [
    PokeType.ROCK,
    PokeType.STEEL
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "double-edge",
    "rock-slide",
    "protect",
    "endure",
    "swagger",
    "ancient-power",
    "taunt",
    "metal-sound",
    "iron-defense",
    "block",
    "metal-burst",
    "earth-power",
    "iron-head",
    "stealth-rock",
    "heavy-slam"
  ],
  "moves": [
    "tackle",
    "rock-slide",
    "protect",
    "ancient-power",
    "metal-sound",
    "metal-burst",
    "earth-power",
    "stealth-rock",
    "steel-beam",
    "scrap-throw",
    "power-siphon",
    "rock-throw",
    "rock-tomb"
  ],
  "evolution_chain": {
    "id": 212,
    "item": null,
    "species": [
      {
        "name": "shieldon",
        "order": 438,
        "types": [
          PokeType.ROCK,
          PokeType.STEEL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "bastiodon",
        "order": 439,
        "types": [
          PokeType.ROCK,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 410,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 213,
    "speed": 60,
    "ability_power": 104
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
